import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Login from '../pages/login/login';
import OrderPrice from '../pages/orderPrice/orderPrice';
import Projects from '../pages/projects/projects';

export default function SignRoutes(){
    return (
        <BrowserRouter>
            <Routes >
                <Route path="/" Component={Login} />
                <Route path="/orderPrice/:key" Component={OrderPrice} />
                <Route path="/orderPrice" Component={OrderPrice} />
                <Route path="/projects/:key" Component={Projects} />
                <Route path="/projects" Component={Projects} />
            </Routes>
        </BrowserRouter>
    );
}